import Vue from 'vue'
import Router from 'vue-router'

import RestaurantPage from '@/components/restaurant/RestaurantPage'
import Profile from '@/components/profile/Profile'

import MenuList from '@/components/menu/MenuList'
import MenuDetailPage from '@/components/menudetail/MenuDetailPage'
// import MenuDetail from '@/components/menu/MenuDetail'

import CheckoutCart from '@/components/cart/CheckoutCart'
import ConfirmOrder from '@/components/order/OrderPaidDetail'
import OrderHistory from '@/components/order/OrderHistory'

import AuthPhoneNumber from '@/components/verify/AuthPhoneNumber'
import AuthPhoneNumberOTP from '@/components/verify/AuthPhoneNumberOTP'
import VerifyInfo from '@/components/verify/VerifyInfo'

import PaymentQRPage from '@/components/payment/PaymentQRPage'

import PageNotReciveOrder from '@/components/page/PageNotReciveOrder'
import PageNotFound from '@/components/page/PageNotFound'

import store from '@/store/index.js'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/restaurant/:restaurant_uuid',
      name: 'RestaurantPage',
      props: true,
      component: RestaurantPage
    },
    {
      path: '/restaurant/:restaurant_uuid/:branch_uuid',
      name: 'MenuList',
      props: true,
      component: MenuList,
      meta: {
        skipBeforeEach: true
      }
    },
    {
      path: '/restaurant/:restaurant_uuid/:branch_uuid/menu/:menu_uuid',
      name: 'MenuDetail',
      props: true,
      component: MenuDetailPage
    },
    {
      path: '/restaurant/:restaurant_uuid/:branch_uuid/profile',
      name: 'Profile',
      props: true,
      component: Profile
    },
    {
      path: '/restaurant/:restaurant_uuid/:branch_uuid/order/history',
      name: 'OrderHistory',
      props: true,
      component: OrderHistory,
      beforeEnter: (to, from, next) => {
        store.dispatch('onAuthStateChanged').then((login) => {
          if (login) {
            next()
          } else {
            next({ path: `/restaurant/${to.params.restaurant_uuid}/${to.params.branch_uuid}/verify/phonenumber` })
          }
        })
      }
    },
    {
      path: '/restaurant/:restaurant_uuid/:branch_uuid/checkout',
      name: 'CheckoutCart',
      props: true,
      component: CheckoutCart,
      beforeEnter: (to, from, next) => {
        // store.dispatch('getCart', JSON.parse(localStorage.getItem('cart-' + to.params.branch_uuid)))
        next()
      }
    },
    {
      path: '/restaurant/:restaurant_uuid/:branch_uuid/confirmorder',
      name: 'ConfirmOrder',
      props: true,
      component: ConfirmOrder,
      beforeEnter: (to, from, next) => {
        store.dispatch('onAuthStateChanged').then((login) => {
          if (login) {
            store.dispatch('getLastOrder', { oid: to.query.oid }).then((res) => {
              if (res) {
                next()
              }
            })
          } else {
            next({ path: `/restaurant/${to.params.restaurant_uuid}/${to.params.branch_uuid}/verify/phonenumber` })
          }
        })
      }
    },
    {
      path: '/restaurant/:restaurant_uuid/:branch_uuid/verify/phonenumber',
      name: 'AuthPhoneNumber',
      props: true,
      component: AuthPhoneNumber,
      beforeEnter: (to, from, next) => {
        store.dispatch('onAuthStateChanged').then((login) => {
          if (login) {
            next({ path: `/restaurant/${to.params.restaurant_uuid}/${to.params.branch_uuid}/order/history` })
          } else {
            next()
          }
        })
      }
    },
    {
      path: '/restaurant/:restaurant_uuid/:branch_uuid/verify/otp',
      name: 'AuthPhoneNumberOTP',
      props: true,
      component: AuthPhoneNumberOTP,
      beforeEnter: (to, from, next) => {
        store.dispatch('onAuthStateChanged').then((login) => {
          if (login) {
            next({ path: `/restaurant/${to.params.restaurant_uuid}/${to.params.branch_uuid}/order/history` })
          } else {
            next()
          }
        })
      }
    },
    {
      path: '/restaurant/:restaurant_uuid/:branch_uuid/verify/info',
      name: 'VerifyInfo',
      props: true,
      component: VerifyInfo,
      beforeEnter: (to, from, next) => {
        store.dispatch('onAuthStateChanged').then((login) => {
          if (!login) {
            next({ path: `/restaurant/${to.params.restaurant_uuid}/${to.params.branch_uuid}/verify/phonenumber` })
          } else {
            store.dispatch('getNewUser').then((newuser) => {
              if (!newuser) {
                next()
              } else {
                next({ path: `/restaurant/${to.params.restaurant_uuid}/${to.params.branch_uuid}/checkout` })
              }
            })
          }
        })
      }
    },
    {
      path: '/restaurant/:restaurant_uuid/:branch_uuid/qr',
      name: 'PaymentQRPage',
      props: true,
      component: PaymentQRPage,
      beforeEnter: (to, from, next) => {
        store.dispatch('onAuthStateChanged').then((login) => {
          if (!login) {
            next({ path: `/restaurant/${to.params.restaurant_uuid}/${to.params.branch_uuid}/verify/phonenumber` })
          } else {
            store.dispatch('recheckQRPayment', { 'rcp': to.query.rcp, 'unq': to.query.unq, 'uid': to.query.uid }).then((response) => {
              if (!response) {
                store.dispatch('getQRCode', { 'rcp': to.query.rcp, 'unq': to.query.unq, 'uid': to.query.uid }).then((res) => {
                  if (res) {
                    next()
                  } else {
                    next({ path: `/restaurant/${to.params.restaurant_uuid}/${to.params.branch_uuid}/order/history` })
                  }
                })
              } else {
                next({ path: `/restaurant/${to.params.restaurant_uuid}/${to.params.branch_uuid}/order/history` })
              }
            })
          }
        })
      }
    },
    {
      path: '/restaurant/:restaurant_uuid/:branch_uuid/close',
      name: 'PageNotReciveOrder',
      props: false,
      component: PageNotReciveOrder
    },
    {
      path: '*',
      name: 'PageNotFound',
      component: PageNotFound,
      meta: {
        skipBeforeEach: true
      }
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js